import React from "react";
import styles from "./health-bingo-modal.module.scss";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "lib/i18n/use-translation";
import { HEALTH_BINGO_END, getHealthBingoUrl } from "../health-bingo/constants";

interface HealthBingoModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

function HealthBingoModal({ isOpen, onDismiss }: HealthBingoModalProps) {
  const { t } = useTranslation(["home"]);

  if (new Date() >= HEALTH_BINGO_END) return null;
  const handleCta = () => {
    window.open(getHealthBingoUrl(), "_blank", "noopener");
    onDismiss();
  };

  return (
    <Modal
      className={styles["health-bingo-modal"]}
      contentClassName={styles["health-bingo-modal-content"]}
      isOpen={isOpen}
    >
      <ModalHeader className={styles["header"]} toggle={onDismiss} />
      <ModalBody className={styles["body"]}>
        <h1 className={styles["title"]}>{t("home:healthBingo.title")}</h1>
        <p className={styles["description"]}>
          {t("home:healthBingo.modalDescription")}
        </p>
        <p className={styles["urgency"]}>
          {t("home:healthBingo.modalUrgency")}
        </p>
      </ModalBody>
      <ModalFooter className={styles["footer"]}>
        <button className={styles["cta-button"]} onClick={handleCta}>
          {t("home:healthBingo.cta")}
        </button>
        <button className={styles["dismiss-button"]} onClick={onDismiss}>
          {t("home:healthBingo.dismiss")}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default HealthBingoModal;
